const sanitas = {
    compañia: 'sanitas',
    gama: {
        'superEconomico': {
            'Sanitas Esencial': {
                Titulares: {
                    0: 2064,
                    1: 2064,
                    2: 2064,
                    3: 2064,
                    4: 2064,
                    5: 2064,
                    6: 2064,
                    7: 2064,
                    8: 2064,
                    9: 2064,
                    10: 1392,
                    11: 1392,
                    12: 1392,
                    13: 1392,
                    14: 1392,
                    15: 2652,
                    16: 2652,
                    17: 2652,
                    18: 2652,
                    19: 2652,
                    20: 2652,
                    21: 2652,
                    22: 2652,
                    23: 2652,
                    24: 2652,
                    25: 2652,
                    26: 2652,
                    27: 2652,
                    28: 2652,
                    29: 2652,
                    30: 2652,
                    31: 2652,
                    32: 2652,
                    33: 2652,
                    34: 2652,
                    35: 2652,
                    36: 2652,
                    37: 2652,
                    38: 2652,
                    39: 2652,
                    40: 2652,
                    41: 2652,
                    42: 2652,
                    43: 2652,
                    44: 2652,
                    45: 5856,
                    46: 5856,
                    47: 5856,
                    48: 5856,
                    49: 5856,
                    50: 5856,
                    51: 5856,
                    52: 5856,
                    53: 5856,
                    54: 5856,
                    55: 5856,
                    56: 5856,
                    57: 5856,
                    58: 5856,
                    59: 5856,
                    60: 10260,
                    61: 10260,
                    62: 10260,
                    63: 10260,
                    64: 10260,
                    65: 12948,
                    66: 12948,
                    67: 12948,
                    68: 12948,
                    69: 12948,
                    70: 14892,

                }
            },
        },
        'economico': {
            'Sanitas Esencial Plus': {
                Titulares: {
                    0: 2436,
                    1: 2436,
                    2: 2436,
                    3: 2436,
                    4: 2436,
                    5: 2436,
                    6: 2436,
                    7: 2436,
                    8: 2436,
                    9: 2436,
                    10: 1548,
                    11: 1548,
                    12: 1548,
                    13: 1548,
                    14: 1548,
                    15: 2808,
                    16: 2808,
                    17: 2808,
                    18: 2808,
                    19: 2808,
                    20: 2808,
                    21: 2808,
                    22: 2808,
                    23: 2808,
                    24: 2808,
                    25: 2808,
                    26: 2808,
                    27: 2808,
                    28: 2808,
                    29: 2808,
                    30: 2808,
                    31: 2808,
                    32: 2808,
                    33: 2808,
                    34: 2808,
                    35: 2808,
                    36: 2808,
                    37: 2808,
                    38: 2808,
                    39: 2808,
                    40: 2808,
                    41: 2808,
                    42: 2808,
                    43: 2808,
                    44: 2808,
                    45: 6108,
                    46: 6108,
                    47: 6108,
                    48: 6108,
                    49: 6108,
                    50: 6108,
                    51: 6108,
                    52: 6108,
                    53: 6108,
                    54: 6108,
                    55: 6108,
                    56: 6108,
                    57: 6108,
                    58: 6108,
                    59: 6108,
                    60: 10488,
                    61: 10488,
                    62: 10488,
                    63: 10488,
                    64: 10488,
                    65: 13188,
                    66: 13188,
                    67: 13188,
                    68: 13188,
                    69: 13188,
                    70: 15288

                }
            },
        },
        'basico': {
            'Sanitas Más Salud': {
                Titulares: {
                    0: 2616,
                    1: 2616,
                    2: 2616,
                    3: 2616,
                    4: 2616,
                    5: 2616,
                    6: 2616,
                    7: 2616,
                    8: 2616,
                    9: 2616,
                    10: 2016,
                    11: 2016,
                    12: 2016,
                    13: 2016,
                    14: 2016,
                    15: 3528,
                    16: 3528,
                    17: 3528,
                    18: 3528,
                    19: 3528,
                    20: 3528,
                    21: 3528,
                    22: 3528,
                    23: 3528,
                    24: 3528,
                    25: 3528,
                    26: 3528,
                    27: 3528,
                    28: 3528,
                    29: 3528,
                    30: 3528,
                    31: 3528,
                    32: 3528,
                    33: 3528,
                    34: 3528,
                    35: 3528,
                    36: 3528,
                    37: 3528,
                    38: 3528,
                    39: 3528,
                    40: 3528,
                    41: 3528,
                    42: 3528,
                    43: 3528,
                    44: 3528,
                    45: 6960,
                    46: 6960,
                    47: 6960,
                    48: 6960,
                    49: 6960,
                    50: 6960,
                    51: 6960,
                    52: 6960,
                    53: 6960,
                    54: 6960,
                    55: 6960,
                    56: 6960,
                    57: 6960,
                    58: 6960,
                    59: 6960,
                    60: 13140,
                    61: 13140,
                    62: 13140,
                    63: 13140,
                    64: 13140,
                    65: 14556,
                    66: 14556,
                    67: 14556,
                    68: 14556,
                    69: 14556,
                    70: 17868,
                }
            },
        },
        'gamaAlta': {
            'Sanitas Premium': {
                Titulares: {
                    0: 3336,
                    1: 3336,
                    2: 3336,
                    3: 3336,
                    4: 3336,
                    5: 3336,
                    6: 3336,
                    7: 3336,
                    8: 3336,
                    9: 3336,
                    10: 2484,
                    11: 2484,
                    12: 2484,
                    13: 2484,
                    14: 2484,
                    15: 4248,
                    16: 4248,
                    17: 4248,
                    18: 4248,
                    19: 4248,
                    20: 4248,
                    21: 4248,
                    22: 4248,
                    23: 4248,
                    24: 4248,
                    25: 4248,
                    26: 4248,
                    27: 4248,
                    28: 4248,
                    29: 4248,
                    30: 4248,
                    31: 4248,
                    32: 4248,
                    33: 4248,
                    34: 4248,
                    35: 4248,
                    36: 4248,
                    37: 4248,
                    38: 4248,
                    39: 4248,
                    40: 4248,
                    41: 4248,
                    42: 4248,
                    43: 4248,
                    44: 4248,
                    45: 9900,
                    46: 9900,
                    47: 9900,
                    48: 9900,
                    49: 9900,
                    50: 9900,
                    51: 9900,
                    52: 9900,
                    53: 9900,
                    54: 9900,
                    55: 9900,
                    56: 9900,
                    57: 9900,
                    58: 9900,
                    59: 9900,
                    60: 14472,
                    61: 14472,
                    62: 14472,
                    63: 14472,
                    64: 14472,
                    65: 18588,
                    66: 18588,
                    67: 18588,
                    68: 18588,
                    69: 18588,
                    70: 19644,
                    71: 19644,
                    72: 19644,
                    73: 19644,
                    74: 19644,
                    75: 19644,
                    76: 19644,
                    77: 19644,
                    78: 19644,
                    79: 19644,
                    80: 19644
                }
            },
        },
    }
}
export default sanitas